import { createContext, useContext } from 'react'

/*
 * A card action is running (useFormActions: a save, a delete...). CardView
 * provides it; the card's buttons and menus — title bar and sections alike —
 * read it to disable themselves, so nothing starts a second action meanwhile.
 */
export const CardBusyContext = createContext(false)

export const useCardBusy = () => useContext(CardBusyContext)
